import React, { Component } from "react";
import PropTypes from "prop-types";

export default class CurriculumItem extends Component {
  
  render() {
    return (
      <div id="acs-codes" className="text-left">
        <em><h6><strong><span className={`learning-key-code tag-subject-${this.props.subjectId} mr-1`}>{this.props.code} </span>
          {this.props.strandName} &#187; {this.props.title}</strong></h6></em>
        <p>{this.props.description}</p>
      </div>
    );
  }
}

CurriculumItem.propTypes = {
  code: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  strandName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subjectId: PropTypes.number.isRequired,
};

CurriculumItem.defaultProps = {
  code: "code",
  description:
    "description",
  strandName: "strand name",
  title: "title",
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/CurriculumBlock/CurriculumItem.js